import { render, staticRenderFns } from "./RewardsAfterAuth.vue?vue&type=template&id=1be453d6&scoped=true"
import script from "./RewardsAfterAuth.vue?vue&type=script&lang=js"
export * from "./RewardsAfterAuth.vue?vue&type=script&lang=js"
import style0 from "./RewardsAfterAuth.vue?vue&type=style&index=0&id=1be453d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be453d6",
  null
  
)

export default component.exports